import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import HelpIcon from '@mui/icons-material/Help';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import BarChartIcon from "@mui/icons-material/BarChart";
import GradingIcon from "@mui/icons-material/Grading";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SettingsIcon from "@mui/icons-material/Settings";
import { Button } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import RateReviewIcon from '@mui/icons-material/RateReview';
import { ContextData } from "../context/Context";
import GetAdminCredentials from "../context/GetAdminCredentials";
import Tooltip from '@mui/material/Tooltip';
import { SupportAgent } from "@mui/icons-material";



const drawerWidth = 240;



const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));



export default function IndexMerchant() {


  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [StatisticsStatus, setStatisticsStatus] = React.useState(true);
  const Navigate = useNavigate();
  const Location = useLocation();
  const isDashboardRoot = Location.pathname === "/dashboard"; 
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const [Changeroutes, setChangeroutes] = React.useState(null);
  const [UserType,setUserType] = React.useState("")
  const  user_roles = [
          "Administrator",
          "Manage",
          "Selector",
          "Validator",
          "Verifier",
          "Bank reviewer",
          "account-helper",
           "Manage Loan",
          "Manage Scholarship",
          "Manage Loan General"
           ]
 

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const checkStaticticsRoute = () => {


    if( Location.pathname === "/dashboard/report_statistics" ){

      Navigate("/dashboard/statistics") 
      setStatisticsStatus(true)

    }else{

      Navigate("/dashboard/report_statistics") 
      setStatisticsStatus(false)
    }


  };


  const {accesstoken,UserTokens} = React.useContext(ContextData)

    React.useEffect(()=>{

        (async ()=>{

                GetAdminCredentials(UserTokens,accesstoken).then(res =>{
                     setUserType(res)
                })
               
        })()



    },[]) 

   
    
  React.useEffect(() => {
  

    if (UserType) {

      if (UserType[0].acct_typ === user_roles[0]) {

       setChangeroutes ([
         {
           path: "adminusers",
           name: "Admin Users",
           icon: <SupervisorAccountIcon />,
         },
         { 
           path: "statistics",
           name: "Statistics",
           icon: <BarChartIcon />,
         },
         {
           path: "setpayment",
           name: "Set Scholarship",
           icon: <RequestQuoteIcon />,
         },  
          {
           path: "setloan",
           name: "Set Loan",
           icon: <RequestQuoteIcon />,
         },  
         {
           path: "selection",
           name: "selection",
           icon: <AppRegistrationIcon />,
         },
         {
           path: "applicants",
           name: "Applicants",
           icon: <GroupAddIcon />,
         },
         {
           path: "account-helper",
           name: "Account Helper",
           icon: <HelpIcon />,
         },
         {
           path: "reviewer",
           name: "Reviewer",
           icon: <RateReviewIcon />,
         },
         {
           path: "award",
           name: "Award",
           icon: <EmojiEventsIcon />,
         },
         {
           path: "dispute",
           name: "Dispute",
           icon: <GradingIcon />,
         },
         {
           path: "verification",
           name: "Verification",
           icon: <TaskAltIcon />,
         },
          {
           path: "approval_loan",
           name: "Loan Approval",
           icon: <AppRegistrationIcon />,
         },
          {
           path: "bank_reviewer",
           name: "Bank Reviewer",
           icon: <TaskAltIcon />,
         },
                   ])

        return;


      }


        if (UserType[0].acct_typ === user_roles[1]) {

       setChangeroutes ([
        
         { 
           path: "statistics",
           name: "Statistics",
           icon: <BarChartIcon />,
         },
        
          {
           path: "setloan",
           name: "Set Loan",
           icon: <RequestQuoteIcon />,
         },  
         {
           path: "selection",
           name: "selection",
           icon: <AppRegistrationIcon />,
         },
         {
           path: "applicants",
           name: "Applicants",
           icon: <GroupAddIcon />,
         },
         {
           path: "account-helper",
           name: "Account Helper",
           icon: <HelpIcon />,
         },
         {
           path: "reviewer",
           name: "Reviewer",
           icon: <RateReviewIcon />,
         },
         {
           path: "award",
           name: "Award",
           icon: <EmojiEventsIcon />,
         },
         {
           path: "dispute",
           name: "Dispute",
           icon: <GradingIcon />,
         },
          {
           path: "approval_loan",
           name: "Approval Loan",
           icon: <AppRegistrationIcon />,
         },
          {
           path: "bank_reviewer",
           name: "Bank Reviewer",
           icon: <TaskAltIcon />,
         },
                   ])

        return;


      }


       if (UserType[0].acct_typ === user_roles[7]) {

       setChangeroutes ([
        
        
          {
           path: "approval_loan",
           name: "Loan Approval",
           icon: <AppRegistrationIcon />,
         },
          {
           path: "applicants",
           name: "Applicants",
           icon: <GroupAddIcon />,
         },

         
])

        return;


      }


      
         if (UserType[0].acct_typ === user_roles[2]) {
        setChangeroutes([
            {
           path: "selection",
           name: "selection",
           icon: <AppRegistrationIcon />,
         },
        ]);
        return;
      }


      if (UserType[0].acct_typ === user_roles[3]) {
        setChangeroutes([
            {
           path: "approval_loan",
           name: "Loan Approval",
           icon: <AppRegistrationIcon />,
         },
        ]);
        return;
      }

       if (UserType[0].acct_typ === user_roles[4]) {
        setChangeroutes([
            {
           path: "verification",
           name: "Verification",
           icon: <TaskAltIcon />,
         }, 
         ,
          {
           path: "matrix",
           name: "Matrix",
           icon: <TaskAltIcon />,
         },
          {
           path: "loan_supports",
           name: "Support Applicants",
           icon: <SupportAgent />,
         },
        ]);
        return;
      }

        if (UserType[0].acct_typ === user_roles[5]) {
        setChangeroutes([
           {
           path: "bank_reviewer",
           name: "Bank Reviewer",
           icon: <TaskAltIcon />,
         },
        ]);
        return;
      }



    if (UserType[0].acct_typ === user_roles[5]) {
        setChangeroutes([
            {
           path: "bank_reviewer",
           name: "Bank Reviewer",
           icon: <TaskAltIcon />,
            },
        ]);
        return;
      }

      if (UserType[0].acct_typ === user_roles[6]) {
        setChangeroutes([
          {
           path: "account-helper",
           name: "Account Helper",
           icon: <HelpIcon />,
         },
        ]);
        return;
      }


       if (UserType[0].acct_typ === user_roles[9]) {


         setChangeroutes ([
        
        
           {
            path: "verification",
            name: "Verification",
            icon: <TaskAltIcon />,
          }, 
          {
           path: "approval_loan",
           name: "Loan Approval",
           icon: <AppRegistrationIcon />,
         },
         {
          path: "bank_reviewer",
          name: "Bank Reviewer",
          icon: <TaskAltIcon />,
        },
         {
           path: "disbursement",
           name: "Disbursement",
           icon: <AppRegistrationIcon />,
         },
          {
           path: "dispute",
           name: "Dispute",
           icon: <GradingIcon />,
         },
          {
           path: "applicants",
           name: "Applicants",
           icon: <GroupAddIcon />,
         },
          {
           path: "matrix",
           name: "Matrix",
           icon: <TaskAltIcon />,
         },
         


                   ])
        return;
      }


    

    }

  }, [UserType]);
    


  

  const CheckActiveRoute = (path) => {
    
    let result

    if(Location.pathname === `/dashboard/${path}`){
       result = true
    }else{
      result = false
    }

    return result

}





  return (
    <Box sx={{ display: "flex", marginTop: "20px" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            background: "rgb(0, 24, 69)",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>

          <div className="flex items-center justify-between w-full">
            <Typography
              variant="h6"
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              noWrap
              component="div"
            >
              {" "}
              <p>
                {!open &&  <img src="/assets/newksslb.jpg" alt="logo" className="w-12 rounded-full inline mr-3" />}
                Dashboard
              </p>
              {
              (Location.pathname.slice(
                Location.pathname.lastIndexOf("/") + 1
              ) === "statistics"|| Location.pathname.slice(
                Location.pathname.lastIndexOf("/") + 1
              ) === "report_statistics" ) && (
                <>
                  <Button
                    sx={{ background: "#888" }}
                    variant="contained"
                    onClick={() => checkStaticticsRoute()}
                  >
                    { StatisticsStatus ? "Local Report" : "Statistics"}
                  </Button>
                </>
              )}
            </Typography>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open}>
        <DrawerHeader
          sx={{
            background: "rgb(0, 24, 69)",
            height: "50px",
            color: "#fff",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {open && <img src="/assets/newksslb.jpg" alt="logo" className="w-12 rounded-full" />}
          <h1>Menu</h1>
          <IconButton onClick={handleDrawerClose} sx={{color: "#fff"}}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <div style={{ height: "80%", width: "100%" }}>
          <List>
            {Changeroutes && Changeroutes.map((list, index) => (
              <ListItem key={index} disablePadding sx={{ display: "block",backgroundColor:CheckActiveRoute(list.path) ?`rgb(9, 9, 49)`:null,color:CheckActiveRoute(list.path) ?`white`:null}}>
                  <Tooltip title={list.name} placement="right">
                <ListItemButton
                 
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    Navigate(list.path);
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                      color:CheckActiveRoute(list.path) ?`white`:null
                    }}
                  >
                    {list.icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={list.name}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>

                  </Tooltip>
              </ListItem>
            ))}
          </List>
        </div>
        <Divider />
        <div style={{ height: "20%", width: "100%" }}>
          <List>
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  Navigate("settings");
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <SettingsIcon />
                </ListItemIcon>

                <ListItemText
                  primary="Settings"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  Navigate("audit");
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <VerifiedUserIcon />
                </ListItemIcon>

                <ListItemText primary="Audit" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          </List>
        </div>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, paddingTop: "3rem" }}>
      {isDashboardRoot && (
    <Box
      sx={{
        width: "100%",
        height: "250px",
        background: "linear-gradient(90deg, rgba(0,24,69,1) 0%, rgba(0,44,109,1) 100%)",
        color: "white",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
        padding: "20px"
      }}
    >
      {/* Animated Welcome Message */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          letterSpacing: "2px",
          animation: "fadeIn 1.5s ease-in-out"
        }}
      >
        🎓 Welcome to the Scholarship and Tertiary Education Loans Portal 🎓
      </Typography>

      {/* Sliding Text Captions */}
      <Typography
        variant="h6"
        sx={{
          marginTop: "10px",
          animation: "slideUp 1.5s ease-in-out"
        }}
      >
      Empowering the Youth for Global Leadership.
      </Typography>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  )}

  {/* Page Content */}
  <Outlet />
      </Box>
    </Box>
  );
}
